module.exports = __webpack_public_path__ + "img/Best Sellers Ranking.4045f20d.svg";